"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const decorators_1 = require("../../../../common/decorators");
const ProgressBarContainer = styled_components_1.default.div `
  z-index: 1;
  position: absolute;
  left: 50%;
  bottom: 1vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 1vmin;
  transform: translateX(-50%);

  @media (orientation: portrait) {
    margin-bottom: 4vmin;
  }
`;
const ArrowButton = (0, styled_components_1.default)(material_1.IconButton) `
  padding: 16px;
  min-width: 48px;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08), 0 0 0 2px rgba(0, 0, 0, 0.08);
  border-radius: ${props => (props.$direction === 'left' ? '28px 8px 8px 28px' : '8px 28px 28px 8px')};
  transition: none;

  &:hover,
  &:active,
  &.Mui-focusVisible {
    background-color: rgba(0, 0, 0, 0.75);
  }

  .MuiSvgIcon-root {
    font-size: 3vmin;
    color: white;
  }
`;
const StyledIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  padding: 16px;
  min-width: 48px;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08), 0 0 0 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  transition: none;

  &:hover,
  &:active,
  &.Mui-focusVisible {
    background-color: rgba(0, 0, 0, 0.75);
  }

  .MuiSvgIcon-root {
    font-size: 3vmin;
    color: white;
  }
`;
const DotsContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5vmin;
  padding: calc(16px + 0.75vmin) 16px;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08), 0 0 0 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
`;
const Dot = styled_components_1.default.div `
  width: ${({ isActive }) => (isActive ? '8vmin' : '1.5vmin')};
  height: 1.5vmin;
  border-radius: 1.5vmin;
  background-color: lightgray;
  transition: width 0.3s ease-in-out;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  ${({ isActive, progress }) => isActive &&
    (0, styled_components_1.css) `
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: white;
        width: ${progress}%;
        transition: width 0.1s linear;
      }
    `}
`;
const VISIBLE_DOTS = 5;
const Controller = ({ isCarouselPaused, slides, currentSlide, goToSlide, progress, updateStore }) => {
    const handlePrev = () => {
        goToSlide((currentSlide - 1 + slides.length) % slides.length);
    };
    const handleNext = () => {
        goToSlide((currentSlide + 1) % slides.length);
    };
    (0, react_1.useEffect)(() => {
        if (progress >= 100) {
            goToSlide((currentSlide + 1) % slides.length);
        }
    }, [progress, currentSlide, slides.length, goToSlide]);
    const { displayedDots, start } = (0, react_1.useMemo)(() => {
        const totalDots = slides.length;
        let start = Math.max(0, currentSlide - Math.floor(VISIBLE_DOTS / 2));
        let end = start + VISIBLE_DOTS;
        if (end > totalDots) {
            end = totalDots;
            start = Math.max(0, end - VISIBLE_DOTS);
        }
        return {
            displayedDots: slides.slice(start, end),
            start,
        };
    }, [slides, currentSlide]);
    return (react_1.default.createElement(ProgressBarContainer, null,
        react_1.default.createElement(ArrowButton, { "aria-label": "Previous slide", onClick: handlePrev, "$direction": "left" },
            react_1.default.createElement(icons_material_1.ArrowBack, { fontSize: "inherit" })),
        react_1.default.createElement(StyledIconButton, { onClick: () => updateStore('isCarouselPaused', !isCarouselPaused) }, isCarouselPaused ? react_1.default.createElement(icons_material_1.PlayArrow, { fontSize: "inherit" }) : react_1.default.createElement(icons_material_1.Pause, { fontSize: "inherit" })),
        react_1.default.createElement(DotsContainer, null, displayedDots.map((_, index) => {
            const actualIndex = start + index;
            return (react_1.default.createElement(Dot, { key: actualIndex, isActive: actualIndex === currentSlide, progress: progress, onClick: () => goToSlide(actualIndex) }));
        })),
        react_1.default.createElement(ArrowButton, { "aria-label": "Next slide", onClick: handleNext, "$direction": "right" },
            react_1.default.createElement(icons_material_1.ArrowForward, { fontSize: "inherit" }))));
};
const mapStoreToProps = store => ({
    slides: store.getValue('slides'),
    isCarouselPaused: store.getValue('isCarouselPaused'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(Controller);
